export default [
  {
    id: '09385978-8ec0-426a-9845-702bc2926673',
    name: 'digital-handover',
    path: 'digital-handover',
    meta: { title: '数字化移交' },
    children: [
      {
        id: '74ef06f6-7fbe-4943-96fb-88f7f7671dfe',
        path: 'preload-config',
        name: 'preload-config',
        component(resolve) {
          require(['../views/model-file-management/views/PreloadConfig'], resolve)
        },
        meta: {
          title: '预加载配置',
          materialType: 1,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '6517cde8-91ff-47e8-93f3-f75dbaca1a4a',
        path: '3d-model-management',
        name: '3d-model-management',
        component(resolve) {
          require(['../views/model-file-management/views/ModelBase'], resolve)
        },
        meta: {
          title: '三维模型管理',
          materialType: 1,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            export: {
              id: 5,
              name: 'export',
              desc: '导出',
              access: true,
            },
            download: {
              id: 6,
              name: 'download',
              desc: '下载文件',
              access: true,
            },
          },
        },
      },
    ],
  },
]
